enum LeasingStep {
  LeasingOptions = 'leasingOptions',
}

export default LeasingStep;
